import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ForgerockComponent } from './forge-rock.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [ForgerockComponent],
  imports: [
    BrowserModule,
    RouterModule.forRoot([{path: '', component: ForgerockComponent}, {path: '**', redirectTo: ''}]),
  ],
  providers: [],
  bootstrap: [ForgerockComponent]
})
export class ForgeRockModule {}